import { Breadcrumb, Card, Col, Row, TabsProps } from 'antd';
import { ItemType } from 'antd/lib/breadcrumb/Breadcrumb';
import { FC, ReactNode } from 'react';
import { useIntl } from 'react-intl';
import SvgHome from '../svg/SvgHome';
import './style.scss';
import TabsWrap from '../TabsWrap';

export interface WidgetProps {
  breadcrumbs: string[];
  title: ReactNode;
  content: ReactNode;
  tabProps?: TabsProps;
}

const Widget: FC<WidgetProps> = (props) => {
  const { breadcrumbs, title, content, tabProps } = props;

  const intl = useIntl();

  const items: ItemType[] = [intl.formatMessage({ id: 'common.widget.breadcrumb.home' }), ...breadcrumbs].map(
    (breadcrumb, index) => ({
      title: (
        <>
          {index === 0 && <SvgHome />}
          <span className="custom_widget-breadcrumb-title">{breadcrumb}</span>
        </>
      ),
    }),
  );

  return (
    <Card className="custom_widget" hoverable={false} bordered={false}>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Row align="middle" justify="space-between">
            <Col>
              <Row gutter={[4, 4]}>
                <Col span={24}>
                  <Breadcrumb items={items} className="custom_widget-breadcrumb" />
                </Col>

                <Col span={24}>
                  <span className="custom_widget-title">{title}</span>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>

        {tabProps?.items && tabProps?.onChange && (
          <Col span={24}>
            <TabsWrap {...tabProps} />
          </Col>
        )}

        <Col span={24}>{content}</Col>
      </Row>
    </Card>
  );
};

export default Widget;
